import { StatusStyleCode } from '../common'

export type AppErrorLevel = {
    code: AppErrorLevelCode,
    name: string,
    color: StatusStyleCode,
}

export enum AppErrorLevelCode {
    Error = 'error',
    Warning = 'warning',
    Information = 'information',
}

export const AppErrorLevelSpec: { [key in AppErrorLevelCode]: Omit<AppErrorLevel, 'code'> } = {
    [AppErrorLevelCode.Error]: { name: 'Ошибка', color : StatusStyleCode.Red },
    [AppErrorLevelCode.Warning]: { name: 'Предупреждение', color : StatusStyleCode.Yellow },
    [AppErrorLevelCode.Information]: { name: 'Информация', color : StatusStyleCode.Yellow  },
}